import { render, staticRenderFns } from "./formDetail.vue?vue&type=template&id=34be1577&scoped=true"
import script from "./formDetail.vue?vue&type=script&lang=js"
export * from "./formDetail.vue?vue&type=script&lang=js"
import style0 from "./formDetail.vue?vue&type=style&index=0&id=34be1577&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be1577",
  null
  
)

export default component.exports